// 생성 파일 — tools/generate-theme-minimal.mjs가 emit한다. 직접 수정 금지(생성기 재실행으로 갱신).
// 벽돌 파괴 조각(shatter) 메타: variant별 균열 4단계 텍스처 키 + 조각 bbox(48×20 캔버스 0~1 정규화) +
// stage별 조각 그룹(pieceStageGroups[0..4] — 0=원샷, 1~4=stage. 같은 그룹 조각은 한 덩어리로 비행).
// 균열 PNG와 조각 PNG는 같은 분할 기하에서 파생되어 "죽는 순간 균열 단계만큼 쪼개지는" 일치가 보장된다.
export const BRICK_SHATTER_IMAGE_KEYS = [
  "brick_crack_v0_light",
  "brick_crack_v0_mid",
  "brick_crack_v0_heavy",
  "brick_crack_v0_severe",
  "brick_piece_v0_p0",
  "brick_piece_v0_p1",
  "brick_crack_v1_light",
  "brick_crack_v1_mid",
  "brick_crack_v1_heavy",
  "brick_crack_v1_severe",
  "brick_piece_v1_p0",
  "brick_piece_v1_p1",
  "brick_crack_v2_light",
  "brick_crack_v2_mid",
  "brick_crack_v2_heavy",
  "brick_crack_v2_severe",
  "brick_piece_v2_p0",
  "brick_piece_v2_p1",
  "brick_piece_v2_p2",
  "brick_crack_v3_light",
  "brick_crack_v3_mid",
  "brick_crack_v3_heavy",
  "brick_crack_v3_severe",
  "brick_piece_v3_p0",
  "brick_piece_v3_p1",
  "brick_piece_v3_p2",
  "brick_piece_v3_p3",
  "brick_crack_v4_light",
  "brick_crack_v4_mid",
  "brick_crack_v4_heavy",
  "brick_crack_v4_severe",
  "brick_piece_v4_p0",
  "brick_piece_v4_p1",
  "brick_piece_v4_p2",
  "brick_piece_v4_p3",
  "brick_piece_v4_p4",
  "brick_piece_v4_p5",
  "brick_crack_v5_light",
  "brick_crack_v5_mid",
  "brick_crack_v5_heavy",
  "brick_crack_v5_severe",
  "brick_piece_v5_p0",
  "brick_piece_v5_p1",
  "brick_piece_v5_p2",
  "brick_piece_v5_p3",
  "brick_piece_v5_p4",
  "brick_piece_v5_p5",
  "brick_crack_v6_light",
  "brick_crack_v6_mid",
  "brick_crack_v6_heavy",
  "brick_crack_v6_severe",
  "brick_piece_v6_p0",
  "brick_piece_v6_p1",
  "brick_piece_v6_p2",
  "brick_piece_v6_p3",
  "brick_piece_v6_p4",
  "brick_piece_v6_p5",
  "brick_piece_v6_p6",
  "brick_piece_v6_p7",
  "brick_crack_v7_light",
  "brick_crack_v7_mid",
  "brick_crack_v7_heavy",
  "brick_crack_v7_severe",
  "brick_piece_v7_p0",
  "brick_piece_v7_p1",
  "brick_piece_v7_p2",
  "brick_piece_v7_p3",
  "brick_piece_v7_p4",
  "brick_piece_v7_p5",
  "brick_piece_v7_p6",
  "brick_piece_v7_p7",
  "brick_piece_v7_p8",
] as const;

export type BrickShatterImageKey = (typeof BRICK_SHATTER_IMAGE_KEYS)[number];

export const BRICK_SHATTER_VARIANTS = [
  {
    crackStageTextures: ["", "brick_crack_v0_light", "brick_crack_v0_mid", "brick_crack_v0_heavy", "brick_crack_v0_severe"] as const,
    pieces: [
      { key: "brick_piece_v0_p0", cx: 0.28125, cy: 0.5, w: 0.5625, h: 1 },
      { key: "brick_piece_v0_p1", cx: 0.71875, cy: 0.5, w: 0.5625, h: 1 },
    ],
    pieceStageGroups: [[0, 1], [0, 1], [0, 1], [0, 1], [0, 1]] as const,
  },
  {
    crackStageTextures: ["", "brick_crack_v1_light", "brick_crack_v1_mid", "brick_crack_v1_heavy", "brick_crack_v1_severe"] as const,
    pieces: [
      { key: "brick_piece_v1_p0", cx: 0.5, cy: 0.325, w: 1, h: 0.65 },
      { key: "brick_piece_v1_p1", cx: 0.5, cy: 0.675, w: 1, h: 0.65 },
    ],
    pieceStageGroups: [[0, 1], [0, 1], [0, 1], [0, 1], [0, 1]] as const,
  },
  {
    crackStageTextures: ["", "brick_crack_v2_light", "brick_crack_v2_mid", "brick_crack_v2_heavy", "brick_crack_v2_severe"] as const,
    pieces: [
      { key: "brick_piece_v2_p0", cx: 0.20833333333333334, cy: 0.5, w: 0.4166666666666667, h: 1 },
      { key: "brick_piece_v2_p1", cx: 0.5, cy: 0.5, w: 0.4166666666666667, h: 1 },
      { key: "brick_piece_v2_p2", cx: 0.8020833333333334, cy: 0.5, w: 0.3958333333333333, h: 1 },
    ],
    pieceStageGroups: [[0, 1, 1], [0, 1, 1], [0, 1, 1], [0, 1, 2], [0, 1, 2]] as const,
  },
  {
    crackStageTextures: ["", "brick_crack_v3_light", "brick_crack_v3_mid", "brick_crack_v3_heavy", "brick_crack_v3_severe"] as const,
    pieces: [
      { key: "brick_piece_v3_p0", cx: 0.28125, cy: 0.3, w: 0.5625, h: 0.6 },
      { key: "brick_piece_v3_p1", cx: 0.7291666666666666, cy: 0.325, w: 0.5416666666666666, h: 0.65 },
      { key: "brick_piece_v3_p2", cx: 0.2604166666666667, cy: 0.7, w: 0.5208333333333334, h: 0.6 },
      { key: "brick_piece_v3_p3", cx: 0.71875, cy: 0.675, w: 0.5625, h: 0.65 },
    ],
    pieceStageGroups: [[0, 1, 0, 1], [0, 1, 0, 1], [0, 1, 0, 1], [0, 1, 2, 3], [0, 1, 2, 3]] as const,
  },
  {
    crackStageTextures: ["", "brick_crack_v4_light", "brick_crack_v4_mid", "brick_crack_v4_heavy", "brick_crack_v4_severe"] as const,
    pieces: [
      { key: "brick_piece_v4_p0", cx: 0.19791666666666666, cy: 0.3, w: 0.3958333333333333, h: 0.6 },
      { key: "brick_piece_v4_p1", cx: 0.4791666666666667, cy: 0.325, w: 0.4583333333333333, h: 0.65 },
      { key: "brick_piece_v4_p2", cx: 0.8125, cy: 0.3, w: 0.375, h: 0.6 },
      { key: "brick_piece_v4_p3", cx: 0.19791666666666666, cy: 0.675, w: 0.3958333333333333, h: 0.65 },
      { key: "brick_piece_v4_p4", cx: 0.4895833333333333, cy: 0.7, w: 0.4375, h: 0.6 },
      { key: "brick_piece_v4_p5", cx: 0.8125, cy: 0.675, w: 0.375, h: 0.65 },
    ],
    pieceStageGroups: [[0, 1, 1, 0, 1, 1], [0, 1, 1, 0, 1, 1], [0, 1, 2, 0, 1, 2], [0, 1, 2, 0, 1, 2], [0, 1, 2, 3, 4, 5]] as const,
  },
  {
    crackStageTextures: ["", "brick_crack_v5_light", "brick_crack_v5_mid", "brick_crack_v5_heavy", "brick_crack_v5_severe"] as const,
    pieces: [
      { key: "brick_piece_v5_p0", cx: 0.2916666666666667, cy: 0.225, w: 0.5833333333333334, h: 0.45 },
      { key: "brick_piece_v5_p1", cx: 0.7395833333333334, cy: 0.25, w: 0.5208333333333334, h: 0.5 },
      { key: "brick_piece_v5_p2", cx: 0.28125, cy: 0.5, w: 0.5625, h: 0.6 },
      { key: "brick_piece_v5_p3", cx: 0.71875, cy: 0.5, w: 0.5625, h: 0.6 },
      { key: "brick_piece_v5_p4", cx: 0.2604166666666667, cy: 0.775, w: 0.5208333333333334, h: 0.45 },
      { key: "brick_piece_v5_p5", cx: 0.7083333333333334, cy: 0.775, w: 0.5833333333333334, h: 0.45 },
    ],
    pieceStageGroups: [[0, 1, 0, 1, 0, 1], [0, 1, 0, 1, 0, 1], [0, 1, 2, 3, 2, 3], [0, 1, 2, 3, 2, 3], [0, 1, 2, 3, 4, 5]] as const,
  },
  {
    crackStageTextures: ["", "brick_crack_v6_light", "brick_crack_v6_mid", "brick_crack_v6_heavy", "brick_crack_v6_severe"] as const,
    pieces: [
      { key: "brick_piece_v6_p0", cx: 0.13541666666666666, cy: 0.3, w: 0.2708333333333333, h: 0.6 },
      { key: "brick_piece_v6_p1", cx: 0.34375, cy: 0.3, w: 0.3958333333333333, h: 0.6 },
      { key: "brick_piece_v6_p2", cx: 0.5833333333333334, cy: 0.3, w: 0.4166666666666667, h: 0.6 },
      { key: "brick_piece_v6_p3", cx: 0.84375, cy: 0.3, w: 0.3125, h: 0.6 },
      { key: "brick_piece_v6_p4", cx: 0.13541666666666666, cy: 0.675, w: 0.2708333333333333, h: 0.65 },
      { key: "brick_piece_v6_p5", cx: 0.3229166666666667, cy: 0.675, w: 0.3541666666666667, h: 0.65 },
      { key: "brick_piece_v6_p6", cx: 0.625, cy: 0.725, w: 0.4166666666666667, h: 0.55 },
      { key: "brick_piece_v6_p7", cx: 0.875, cy: 0.675, w: 0.25, h: 0.65 },
    ],
    pieceStageGroups: [[0, 1, 1, 1, 0, 1, 1, 1], [0, 1, 1, 1, 0, 1, 1, 1], [0, 1, 2, 2, 0, 1, 2, 2], [0, 1, 2, 3, 0, 1, 2, 3], [0, 1, 2, 3, 4, 5, 6, 7]] as const,
  },
  {
    crackStageTextures: ["", "brick_crack_v7_light", "brick_crack_v7_mid", "brick_crack_v7_heavy", "brick_crack_v7_severe"] as const,
    pieces: [
      { key: "brick_piece_v7_p0", cx: 0.19791666666666666, cy: 0.225, w: 0.3958333333333333, h: 0.45 },
      { key: "brick_piece_v7_p1", cx: 0.5, cy: 0.225, w: 0.3333333333333333, h: 0.45 },
      { key: "brick_piece_v7_p2", cx: 0.8020833333333334, cy: 0.225, w: 0.3958333333333333, h: 0.45 },
      { key: "brick_piece_v7_p3", cx: 0.19791666666666666, cy: 0.5, w: 0.3958333333333333, h: 0.5 },
      { key: "brick_piece_v7_p4", cx: 0.5, cy: 0.5, w: 0.375, h: 0.5 },
      { key: "brick_piece_v7_p5", cx: 0.8125, cy: 0.525, w: 0.375, h: 0.55 },
      { key: "brick_piece_v7_p6", cx: 0.1875, cy: 0.775, w: 0.375, h: 0.45 },
      { key: "brick_piece_v7_p7", cx: 0.4895833333333333, cy: 0.75, w: 0.4791666666666667, h: 0.5 },
      { key: "brick_piece_v7_p8", cx: 0.8125, cy: 0.775, w: 0.375, h: 0.45 },
    ],
    pieceStageGroups: [[0, 1, 1, 0, 1, 1, 0, 1, 1], [0, 1, 1, 0, 1, 1, 0, 1, 1], [0, 1, 2, 0, 1, 2, 0, 1, 2], [0, 1, 2, 3, 4, 5, 3, 4, 5], [0, 1, 2, 3, 4, 5, 6, 7, 8]] as const,
  },
] as const;
